export const DEFAULT_LOAD_COUNT = 10;
export const DEFAULT_SORTING_COLUMN = "added";
